import { Wrapper } from './DetailsCarouselWrapper.styled'

const DetailsCarouselWrapper: React.FC = ({ children }) => {
  return <Wrapper>{children}</Wrapper>
}

export default DetailsCarouselWrapper
